export default __webpack_public_path__ + "static/media/demopic1.a78a7073.png";